import { initDatabasesRovoContentBridge } from '@databases/rovo-bridge';

import { type Recyclable } from './types';

export function initializeDatabasesRovoBridge(): Recyclable {
  let teardown: (() => void) | undefined;

  return {
    setup(contentId: string) {
      ({ teardown } = initDatabasesRovoContentBridge(contentId));
    },
    dispose() {
      teardown?.();
      teardown = undefined;
    },
  };
}
